/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import StarRatingNew from './StarRating';
import { formatCurrency, isEmpty } from '../../../shared/helper-utils/appUtils';
import { useAppContext } from '../../../saas/AppConfigWrapper';

function HotelEmailContent({
  hotelList,
  searchQuery,
  showInput,
  markUpToBeAdded,
  showBreakup,
}) {
  const { appConfig } = useAppContext();
  const getAmount = (val) => {
    const markup = markUpToBeAdded === '' ? 0 : parseInt(markUpToBeAdded, 10);
    return formatCurrency(parseInt(val, 10) + markup);
  };
  return (
    <div id="hotelEmailContent">
      <div
        style={{
          // width: '750px',
          color: '#000',
          marginLeft: 'auto',
          marginRight: 'auto',
          borderRadius: '10px',
        }}
      >
        <div
          style={{
            padding: '12px',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
            color: '#fff',
            backgroundColor: appConfig?.clientPrimaryColor,
            fontSize: '14px',
          }}
          className="d-none"
        >
          <table style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td colSpan={4}>
                  <b>Dear Partner,</b>
                </td>
              </tr>
              <tr>
                <td colSpan={4} style={{ paddingBottom: '12px' }}>
                  As per your request, we are forwarding itineraries for{' '}
                  {searchQuery.city}.
                </td>
              </tr>
              <tr>
                <td>
                  <b>City :</b>
                </td>
                <td>{searchQuery.city}</td>
                <td />
                <td />
              </tr>
              <tr>
                <td>
                  <b>Check-in : </b>
                </td>
                <td>{searchQuery.checkInSearch}</td>
                <td>
                  <b>Check Out :</b>
                </td>
                <td>{searchQuery.checkOutSearch}</td>
              </tr>
              <tr>
                <td>
                  <b>Room(s) :</b>
                </td>
                <td>{searchQuery.totrooms}</td>
                <td>
                  <b>No.of Guest(s) :</b>
                </td>
                <td> {searchQuery.totalPeople}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          style={{
            padding: '12px',
            border: `1px solid ${appConfig?.clientPrimaryColor}`,
            // borderBottom: '1px solid #333333',
          }}
        >
          <table
            style={{
              width: '100%',
              borderSpacing: '0',
            }}
          >
            <tbody>
              {hotelList.map((hotel, index) => (
                <React.Fragment key={index}>
                  <tr key={hotel.pbKey}>
                    <td
                      style={{
                        textAlign: 'left',
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#0770e4',
                      }}
                    >
                      {hotel.propertyName}{' '}
                      <StarRatingNew rating={hotel.starRating} />
                    </td>
                    <td
                      style={{
                        textAlign: 'end',
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#000',
                      }}
                    >
                      {showBreakup &&
                        (showInput ? (
                          <span>{formatCurrency(hotel.minPrice)}</span>
                        ) : (
                          <span>{getAmount(hotel.minPrice)}</span>
                        ))}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        fontSize: '12px',
                        color: '#1e1e1e',
                        paddingBottom: !isEmpty(hotel.desc)
                          ? '8px'
                          : hotelList.length - 1
                          ? '8px'
                          : '',
                      }}
                      colSpan={2}
                    >
                      {hotel.shortaddr}
                    </td>
                  </tr>
                  {/* {!isEmpty(hotel.desc) && (
                    <tr>
                      <td
                        style={{
                          fontSize: '12px',
                          color: '#666666',
                          paddingBottom:
                            index !== hotelList.length - 1 ? '8px' : '',
                        }}
                        colSpan={2}
                      >
                        <b>Location: </b> {hotel.desc}
                      </td>
                    </tr>
                  )} */}
                  {index !== hotelList.length - 1 && (
                    <tr>
                      <td
                        colSpan={2}
                        style={{
                          paddingTop: '8px',
                          borderTop: `1px dotted ${appConfig?.clientPrimaryColor}`,
                        }}
                      />
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
        <div
          style={{
            backgroundColor: '#333333',
            color: '#fff',
            padding: '12px',
            fontSize: '12px',
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
          }}
          className="d-none"
        >
          <span style={{ fontSize: '14px', marginBottom: '10px' }}>
            Terms & Conditions:
          </span>
          <ul>
            <li>Prices shown are subject to change at the time of booking</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

HotelEmailContent.propTypes = {
  hotelList: PropTypes.array.isRequired,
  searchQuery: PropTypes.object.isRequired,
  showInput: PropTypes.bool.isRequired,
  showBreakup: PropTypes.bool.isRequired,
  markUpToBeAdded: PropTypes.any.isRequired,
};
export default HotelEmailContent;
